import React from 'react'
import { Header } from '../../styles.style'

const Topo = ({ step }) => {
	return (
		<Header className={step > 5 ? 'hide' : null}>
			<h4>Quase lá...</h4>

			<p>
				Agora precisaremos que você complete alguns dados para finalizarmos
				a sua solicitação
			</p>
		</Header>
	)
}

export default Topo
